import PdfDocumentWrapper from '../../PdfDocumentWrapper'

export const mergeFilesKeyFactory = {
  merge: (projectId?: string, scanId?: string, documents?: PdfDocumentWrapper[]) =>
    ['merge', projectId, scanId, documents?.map((d) => d.id)] as const,
}
